{
  "pageTitle": "Qaydalar və siyasətlər",
  "pageIntro": "Bu sənədlər VBB PLAY üçün hüquqi qaralamadır (DRAFT). Operator şirkəti, lisenziya, qeydiyyat ölkəsi və hədəf bazarlar sahibi tərəfindən təsdiqlənənə qədər mətnlər rəsmi nəşr hesab edilmir. Aşağıdakı qaydalar platformanın hazırkı texniki davranışına uyğunlaşdırılıb; aktiv olmayan funksiyalar «işləyir» kimi təqdim olunmur.",
  "draftBadge": "QARALAMA — hüquqi təsdiq gözlənilir",
  "backToList": "Bütün qaydalara qayıt",
  "updatedLabel": "Versiya",
  "version": "0.4-az-draft",
  "footerNote": "Şirkət adı, lisenziya nömrəsi, hüquqi ünvan və tətbiq olunan hüquq bu qaralamada uydurulmayıb. Canlı nəşr yalnız ayrıca təsdiq və deploy icazəsindən sonra mümkündür.",
  "navTitle": "Qaydalar",
  "categories": {
    "terms": {
      "title": "İstifadə qaydaları",
      "summary": "Hesabın yaradılması, giriş üsulları, öhdəliklər və platformanın hazırkı əhatəsi.",
      "sections": [
        {
          "heading": "1. Platforma və əhatə",
          "body": "VBB PLAY (vbbplay.com) onlayn oyun və əlaqəli hesab xidmətləri təqdim edən veb platformadır. Bu qaydalar qeydiyyat, giriş, profil, kassa sorğuları, bonus və kampaniyalar, Canlı Dəstək və məlumat səhifələrinə şamil olunur. Operatorun rəsmi hüquqi adı, qeydiyyat yurisdiksiyası və lisenziya rekvizitləri bu qaralamada göstərilmir; onlar sahibi tərəfindən təsdiqlənəndən sonra əlavə olunacaq."
        },
        {
          "heading": "2. Qəbul",
          "body": "Qeydiyyat zamanı «istifadə qaydalarını oxumuşam və razıyam» xanasının işarələnməsi və hesabın istifadəsi bu sənədlərin qəbulu sayılır. Qaydalar yeniləndikdə platformada göstərilən versiya tətbiq olunur."
        },
        {
          "heading": "3. Hesab və giriş",
          "body": "Hər fiziki şəxs yalnız bir şəxsi hesab aça bilər. Hazırda əsas giriş və qeydiyyat yolu e-poçt və şifrədir. Telegram vasitəsilə veb giriş aktiv ola bilər. Telefon və SMS təsdiqi hazırda əlçatan deyil. Google ilə giriş yalnız operator tərəfindən aktivləşdirildikdə görünür. Giriş məlumatlarının məxfiliyinə istifadəçi cavabdehdir."
        },
        {
          "heading": "4. Yaş",
          "body": "Platforma minimum 18 yaş yoxlamasını nəzərdə tutur (doğum tarixi əsasında). Hüquqi yaş tələbi və hədəf bazarlarda əlavə məhdudiyyətlər operatorun təsdiqlənmiş uyğunluq qərarından asılıdır. Bu qaralamada ölkə və ya lisenziya iddiası irəli sürülmür."
        },
        {
          "heading": "5. Real pul oyunu və kataloq",
          "body": "Hazırkı iş rejimində real pullu oyun sessiyaları və xarici oyun kataloqu canlıda aktiv hesab edilmir. Bu funksiyalar operator tərəfindən ayrıca aktivləşdirilənə qədər «real oyun əlçatandır» iddiası irəli sürülmür."
        },
        {
          "heading": "6. Qadağalar",
          "body": "Fırıldaqçılıq, çoxlu hesab, avtomatlaşdırılmış sui-istifadə, üçüncü şəxsin hesabına müdaxilə, saxta sənəd və qanunsuz fəaliyyət qadağandır. Pozuntu hesabın məhdudlaşdırılması, bonusların ləğvi və ya bağlanması ilə nəticələnə bilər."
        },
        {
          "heading": "7. Dil və interfeys",
          "body": "Sayt interfeysi azərbaycan, rus, ingilis, qazax, özbək və tacik dillərini dəstəkləyir. Seçilmiş dil cihazda saxlanır və mümkün olduqda hesabla sinxronlaşır. Üçüncü tərəf oyun provayderinin interfeys dili yalnız həmin provayderin dəstəklədiyi dillərlə məhdudlaşır."
        },
        {
          "heading": "8. Əlaqə",
          "body": "İstifadəçi sorğuları üçün Canlı Dəstək kanalı nəzərdə tutulub. Rəsmi hüquqi ünvan və operator rekvizitləri təsdiqdən sonra dərc olunacaq."
        }
      ]
    },
    "privacy": {
      "title": "Məxfilik siyasəti",
      "summary": "Hansı məlumatların toplanması, saxlanması və istifadəçinin hüquqları.",
      "sections": [
        {
          "heading": "1. Toplanan məlumatlar",
          "body": "Hesab identifikatoru, e-poçt, (əgər qoşulubsa) telefon və ya Telegram identifikatorları, profil sahələri (ad, soyad, doğum tarixi, cins — istifadəçi doldurduqda), dil seçimi, ödəniş sorğularının meta-məlumatı, dəstək yazışmaları və texniki jurnallar (IP ünvanı, cihaz və sessiya məlumatı) emal oluna bilər."
        },
        {
          "heading": "2. Məqsəd",
          "body": "Məlumatlar hesabın idarə edilməsi, təhlükəsizlik, autentifikasiya, ödəniş sorğularının emalı, dəstək, fırıldaqçılığın qarşısının alınması və qanuni öhdəliklər üçün istifadə olunur."
        },
        {
          "heading": "3. Paylaşma",
          "body": "Məlumatlar satılmır. Ödəniş tərəfdaşları, e-poçt və ya Telegram xidmət provayderləri, oyun aqreqatoru (aktivləşdirildikdə) və qanunla tələb olunan orqanlarla məhdud paylaşma ola bilər. Konkret tərəfdaş siyahısı operator təsdiqindən sonra yenilənəcək."
        },
        {
          "heading": "4. Saxlama və təhlükəsizlik",
          "body": "Məlumatlar xidmət və qanuni tələblər üçün zəruri müddət saxlanılır. Şifrələr hash olunur; sessiya nişanları təhlükəsizlik tədbirləri ilə idarə olunur. Heç bir sistem 100% riskdən azad deyil."
        },
        {
          "heading": "5. İstifadəçi hüquqları",
          "body": "Profil sahələrinin bir qismi təsdiqdən sonra kilidlənə bilər; dəyişiklik administrator və ya dəstək prosesi ilə aparılır. Məlumatlara baxış, düzəliş və ya silinmə sorğusu Canlı Dəstək vasitəsilə göndərilə bilər (qanuni saxlama istisnaları ilə)."
        },
        {
          "heading": "6. Cookie və dil",
          "body": "Dil seçimi brauzerdə saxlanılır. Sessiyanın işləməsi üçün zəruri texniki cookie və ya nişanlar istifadə oluna bilər."
        }
      ]
    },
    "bonuses": {
      "title": "Bonus qaydaları",
      "summary": "Promo kodlar, kampaniyalar və Şans Çarxı bonusunun qaydaları.",
      "sections": [
        {
          "heading": "1. Ümumi",
          "body": "Bonuslar, promo kodlar və Şans Çarxı mükafatları kampaniya şərtlərinə, hesab statusuna və operatorun aktivləşdirdiyi funksiyalara bağlıdır. Kampaniya növü promo kod, qarşılama, depozit bonusu və ya keşbek ola bilər; istifadəçi tərəfindən birbaşa aktivləşdirmə yalnız müvafiq növlər üçün mümkündür."
        },
        {
          "heading": "2. Real və bonus balans",
          "body": "Pul kisəsində real balans və bonus balansı ayrı uçota alınır. Bonus vəsait birbaşa çıxarışa uyğun hesab edilmir. Çevrilmə yalnız aşağıdakı Şans Çarxı qaydaları tamamlandıqda və operator bu funksiyanı aktivləşdirdikdə mümkündür."
        },
        {
          "heading": "3. Şans Çarxı — dövriyyə və müddət",
          "body": "Şans Çarxı mükafatı əvvəlcə yalnız bonus balansına yazılır. Yeni mükafat üçün dövriyyə tələbi verilmiş məbləğin 30 qatıdır. Yalnız hesablaşmış və bonus balansı ilə ödənilmiş mərclər dövriyyəyə sayılır. Nağd (real) balansı ilə ödənilmiş mərclər, pulsuz turlar və uyğun olmayan oyunlardakı mərclər dövriyyəyə daxil edilmir. Bir mərc ən çox bir mükafata aid edilir. Mükafatın etibarlılıq müddəti yaradılma anından 72 saatdır."
        },
        {
          "heading": "4. Şans Çarxı — mərc, uduş, geri qaytarma və bitmə",
          "body": "Bonusla ödənilən mərc həmin mükafatın qalan bonus balansından çıxılır. Uduş eyni mükafatın bonus balansına yazılır; bonus uduşu birbaşa real balansa keçmir. Provayder mərcı ləğv edib vəsaiti qaytardıqda: mərc məbləği (müddəti bitməmiş mükafat üçün) bonus balansına qaytarılır və həmin mərc üzrə sayılmış dövriyyə irəliləyişi geri alınır. Müddəti bitmiş və ya ləğv olunmuş mükafatın qalan bonus balansı silinir və çevrilmir. Dövriyyə tamamlandıqdan sonra çevrilmə məbləği mükafatın qalan bonus balansına (qalıq mükafat + uduşlar) bərabərdir; əlavə yuxarı limit kodda nəzərdə tutulmayıb. Bu mexanizmlər yalnız operator müvafiq funksiyaları aktivləşdirdikdə tətbiq olunur; hazırkı iş rejimində Şans Çarxı kreditləri, bonusla oyun, dövriyyə və çevrilmə canlıda aktiv hesab edilmir."
        },
        {
          "heading": "5. Promo kod",
          "body": "Promo kod Bonuslar bölməsində daxil edilir. Qeydiyyat formasındakı promo sahəsi avtomatik tətbiq etmir; istifadəçi daxil olduqdan sonra kodu aktivləşdirə bilər. Etibarsız, bitmiş və ya limitə çatmış kodlar rədd edilir."
        },
        {
          "heading": "6. Sui-istifadə",
          "body": "Çoxlu hesab, bonus ovçuluğu və ya şərtlərin yan keçməsi aşkarlanarsa, bonuslar ləğv edilə, hesab məhdudlaşdırıla bilər."
        }
      ]
    },
    "payments": {
      "title": "Depozit və çıxarış",
      "summary": "Kassa sorğuları, üsullar, kripto, limitlər və geri qaytarma prosedurları.",
      "sections": [
        {
          "heading": "1. Kassa və üsullar",
          "body": "Depozit və çıxarış sorğuları Kassa vasitəsilə yaradılır. Depozit üsulları kart, m10, terminal və kripto ola bilər; çıxarış üsulları bank kartı, m10 və kripto ola bilər. Üsul yalnız operator konfiqurasiyasında aktivdirsə və müvafiq rekvizit mövcuddursa qəbul edilir."
        },
        {
          "heading": "2. Limitlər və komissiyalar",
          "body": "Minimum və maksimum məbləğlər hər aktiv rekvizit üçün ayrıca təyin olunur və Kassada göstərilir. Bu qaralamada sabit rəqəmsal limit və ya faiz komissiyası uydurulmur. Şəbəkə, bank və ya ödəniş provayderi tərəfindən tutulan komissiyalar üçüncü tərəfin şərtlərinə görə dəyişə bilər və platformanın göstərdiyi məbləğə əlavə təsir edə bilər."
        },
        {
          "heading": "3. Depozit prosesi",
          "body": "İstifadəçi məbləğ seçir, göstərilən rekvizitə ödəniş edir və tələb olunan hallarda qəbz və ya ödəniş istinadı təqdim edir. Ödəniş müddəti bitmiş, lakin hələ təsdiqlənməmiş sorğu avtomatik olaraq hesabı artırmır. Gecikmiş ödəniş halları yalnız administratorun yenidən baxışı və ayrıca təsdiqi ilə həll edilə bilər; təkrar kredit yalnız bir dəfə mümkündür."
        },
        {
          "heading": "4. Kripto ödənişləri",
          "body": "Kripto depozit və çıxarışda aktiv və şəbəkə düzgün seçilməlidir. Yalnız platformada aktiv olan aktiv/şəbəkə cütlükləri qəbul edilir. Yanlış şəbəkə, yanlış ünvan və ya dəstəklənməyən cütlüyə göndərilmiş vəsait avtomatik kreditləşməyə bilər. Təsdiq sayı şəbəkəyə görə dəyişə bilər. Ünvan və şəbəkə yoxlaması istifadəçinin məsuliyyətidir."
        },
        {
          "heading": "5. Yanlış rekvizit və geri qaytarma",
          "body": "Yanlış rekvizitə, yanlış şəbəkəyə və ya fərqli məbləğlə göndərilmiş ödəniş gecikməyə, rəddə və ya vəsaitin hesaba düşməməsinə səbəb ola bilər. Belə hallarda Canlı Dəstəyə sorğu nömrəsi, tarix, məbləğ, üsul və mümkün sübutlarla müraciət edin. Geri qaytarma və ya düzəliş yalnız faktiki daxilolma təsdiqləndikdə və operator proseduruna uyğun aparılır; uğurlu geri qaytarma zəmanəti verilmir. Üçüncü tərəf şəbəkə və ya bank xətası nəticəsində itirilmiş vəsaitə görə platformanın avtomatik məsuliyyəti bu qaralamada iddia edilmir."
        },
        {
          "heading": "6. Çıxarış prosesi",
          "body": "Çıxarış yalnız real balansa şamil olunur; bonus balansı birbaşa çıxarılmır. Sorğular yoxlanıla bilər. Hesab məhdudiyyəti, soyutma, özünü məhdudlaşdırma, KYC və ya risk siqnalları çıxarışı dayandıra bilər. Təyinat rekvizitinin düzgünlüyünə istifadəçi cavabdehdir."
        },
        {
          "heading": "7. Real oyun ilə əlaqə",
          "body": "Depozit sorğusu qəbul olunsa belə, real pullu oyun sessiyaları operator tərəfindən aktivləşdirilməyənədək açıq hesab edilmir. Ödəniş üsullarının bütün ölkələrdə qanuni olduğu iddiası irəli sürülmür."
        },
        {
          "heading": "8. Valyuta",
          "body": "Əsas hesab valyutası platformanın konfiqurasiyasına uyğundur (hazırda AZN). Kripto və digər üsullarda konvertasiya məzənnəsi və şəbəkə xərcləri üsuldan asılıdır."
        }
      ]
    },
    "responsible": {
      "title": "Məsuliyyətli oyun",
      "summary": "Risklərin azaldılması və hesab qorunması alətləri.",
      "sections": [
        {
          "heading": "1. Prinsip",
          "body": "Oyun əyləncə üçündür. Uduş zəmanəti yoxdur. İtkini ödəyə bilmədiyiniz məbləğlə oynamayın."
        },
        {
          "heading": "2. Platforma alətləri",
          "body": "Ayarlar bölməsində soyutma, özünü məhdudlaşdırma və hesabın bağlanması sorğusu göndərilə bilər. Ətraflı prosedur «Özünü Məhdudlaşdırma Siyasəti»ndə təsvir olunur."
        },
        {
          "heading": "3. Təsir",
          "body": "Soyutma və özünü məhdudlaşdırma depozit, çıxarış və oyun məhdudiyyətlərini aktivləşdirə bilər. Özünü məhdudlaşdırma hesabı qeyri-aktiv edə və sessiyaları ləğv edə bilər. Bağlanma sorğusu da əməliyyat məhdudiyyətləri yaradır."
        },
        {
          "heading": "4. Yetkinlik",
          "body": "18 yaşdan aşağı şəxslərin real pullu iştirakı nəzərdə tutulmur. Doğum tarixi əsasında uyğunsuzluq real oyun uyğunluğunu məhdudlaşdıra bilər."
        },
        {
          "heading": "5. Peşəkar yardım",
          "body": "Asılılıq riski hiss edirsinizsə, peşəkar yardım axtarın. Platforma alətləri tibbi və ya psixoloji yardımı əvəz etmir."
        }
      ]
    },
    "kyc": {
      "title": "Hesabın təsdiqi (KYC)",
      "summary": "Şəxsiyyət, əlaqə və ödənişlə bağlı yoxlama mərhələləri.",
      "sections": [
        {
          "heading": "1. Məqsəd",
          "body": "KYC hesabın təhlükəsizliyini artırmaq, fırıldaqçılığın qarşısını almaq və çıxarış və ya risk hallarında şəxsiyyəti təsdiqləmək üçündür. Rəsmi «Müştərinizi tanıyın» öhdəliyinin həcmi operatorun yurisdiksiya və lisenziya statusundan asılıdır; bu qaralamada konkret tənzimləyici iddia yoxdur."
        },
        {
          "heading": "2. Profil məlumatları",
          "body": "İstifadəçi ad, soyad, doğum tarixi və cins daxil edə bilər. Təsdiqdən sonra bu sahələr kilidlənə bilər; dəyişiklik administrator təsdiqi və ya dəstək prosesi tələb edir."
        },
        {
          "heading": "3. Əlaqə təsdiqi",
          "body": "E-poçt təsdiqi təhlükəsizlik axınında mövcuddur. Telefon təsdiqi hazırda SMS əlçatan olmadığı üçün aktiv hesab edilmir. Telegram hesabı platformanın təklif etdiyi giriş üsulları ilə bağlana bilər."
        },
        {
          "heading": "4. Əlavə sənədlər",
          "body": "Çıxarış, yüksək məbləğ, risk siqnalı və ya admin sorğusu zamanı şəxsiyyət vəsiqəsi və ya pasport, ünvan və ya ödəniş üsuluna dair sübut tələb oluna bilər. Siyahı dəstək tərəfindən dəqiqləşdirilir."
        },
        {
          "heading": "5. Nəticə",
          "body": "Yoxlama tamamlanmayana qədər bəzi əməliyyatlar məhdudlaşdırıla bilər. Uyğunsuzluq və ya saxta sənəd hesabın bağlanmasına səbəb ola bilər."
        }
      ]
    },
    "aml": {
      "title": "AML və fırıldaqçılığa qarşı",
      "summary": "Şübhəli əməliyyatların monitorinqi və tədbirlər.",
      "sections": [
        {
          "heading": "1. Məqsəd",
          "body": "Platforma qanunsuz vəsait axını, fırıldaqçılıq və hesabın sui-istifadəsinin qarşısını almağa çalışır. Tam AML proqramının hüquqi həcmi operatorun təsdiqlənmiş yurisdiksiya öhdəliklərindən asılıdır."
        },
        {
          "heading": "2. Monitorinq",
          "body": "Ödəniş sorğuları, giriş nümunələri, bonus istifadəsi və hesab davranışı avtomatik və ya əl ilə yoxlanıla bilər. Administrator hesab məhdudiyyətləri tətbiq edə bilər."
        },
        {
          "heading": "3. Tədbirlər",
          "body": "Şübhəli fəaliyyətdə depozit və çıxarış dayandırıla, oyun məhdudlaşdırıla, hesab dondurula və ya bağlana bilər. Qanun tələb edərsə, səlahiyyətli orqanlara məlumat verilməsi operator öhdəliyi ola bilər — konkret prosedur təsdiqdən sonra əlavə olunacaq."
        },
        {
          "heading": "4. Əməkdaşlıq",
          "body": "İstifadəçi dəstəyin əlavə məlumat və sənəd sorğularına vaxtında cavab verməlidir. Cavabsızlıq sorğunun rəddinə səbəb ola bilər."
        }
      ]
    },
    "fairplay": {
      "title": "Ədalətli oyun və yaş",
      "summary": "Provayder nəticələri, ədalətlilik və yaş məhdudiyyəti.",
      "sections": [
        {
          "heading": "1. Provayderlər",
          "body": "Oyunlar üçüncü tərəf provayderlər və ya aqreqator vasitəsilə təqdim oluna bilər. Hazırkı iş rejimində xarici oyun kataloqu canlıda aktiv hesab edilmir. Aktivləşdirildikdə provayderin öz qaydaları və ədalətlilik mexanizmləri tətbiq olunur."
        },
        {
          "heading": "2. Nəticələr",
          "body": "Oyun nəticələri provayder sisteminə əsasən müəyyən edilir. Texniki xəta hallarında sessiya yenidən baxıla bilər. Platforma nəticəni əl ilə «düzəltmək» iddiası irəli sürmür."
        },
        {
          "heading": "3. Bonusla oyun",
          "body": "Bonusla maliyyələşən sessiyalar yalnız operator müvafiq funksiyanı aktivləşdirdikdə və uyğun oyunlar üçün mümkündür. Hazırkı iş rejimində Şans Çarxı bonus oyunu canlıda aktiv hesab edilmir."
        },
        {
          "heading": "4. Yaş",
          "body": "Minimum yaş yoxlaması 18-dir. Real pullu oyun yalnız hüquqi yaşa çatmış və uyğun hesab edilən istifadəçilər üçündür."
        },
        {
          "heading": "5. Dil",
          "body": "Provayder interfeysi yalnız dəstəklədiyi dillərdə göstərilir. Seçilmiş dil dəstəklənmirsə, provayderin ehtiyat dili istifadə oluna bilər; bu, platformanın dil seçimini saxtalaşdırmır."
        }
      ]
    },
    "self_exclusion": {
      "title": "Özünü Məhdudlaşdırma Siyasəti",
      "summary": "Soyutma, özünü məhdudlaşdırma və bağlanma sorğusu; oyun dayandırması ilə vəsait qaytarılmasının ayrılması.",
      "sections": [
        {
          "heading": "1. Məqsəd",
          "body": "İstifadəçiyə oyun və maliyyə əməliyyatlarını müvəqqəti dayandırmaq və ya məhdudlaşdırmaq imkanı vermək."
        },
        {
          "heading": "2. Alətlər",
          "body": "Ayarlar → Hesab qorunması bölməsində üç əməliyyat var: soyutma, özünü məhdudlaşdırma və hesabın bağlanması sorğusu."
        },
        {
          "heading": "3. Soyutma",
          "body": "Müddət tələb olunur. Aktivləşdikdə depozit, çıxarış və oyun məhdudlaşdırılır. İnterfeysdə nümunə müddət 7 günə qədər təyin edilə bilər; digər müddətlər operator siyasəti ilə dəqiqləşdirilə bilər."
        },
        {
          "heading": "4. Özünü məhdudlaşdırma — oyun və hesabın dayandırılması",
          "body": "Müddət tələb olunur. Depozit, çıxarış və oyun məhdudlaşır; hesab qeyri-aktiv edilə və aktiv sessiyalar ləğv edilə bilər. Şans Çarxı fırlatması da rədd edilə bilər. Müddət bitənə qədər məhdudiyyətin istifadəçi tərəfindən erkən götürülməsi adətən nəzərdə tutulmur (administrator istisnası ola bilər)."
        },
        {
          "heading": "5. Özünü məhdudlaşdırma — qanuni vəsaitin qaytarılması",
          "body": "Oyun və yeni əməliyyatların dayandırılması ilə real balansdakı qanuni vəsaitin qaytarılması ayrı məsələlərdir. Özünü məhdudlaşdırma və ya soyutma aktiv olduqda sistem çıxarış sorğularını məhdudlaşdırır; buna görə vəsaitin avtomatik çıxarılması baş vermir. Real balansdakı qanuni vəsaitin qaytarılması üçün istifadəçi Canlı Dəstəyə müraciət etməlidir. Baxış, KYC və risk yoxlamasından sonra operator əl ilə çıxarış və ya köçürmə proseduru apara bilər. Bonus balansı və müddəti bitmiş mükafatlar çıxarışa uyğun hesab edilmir. Konkret müddət, komissiya və avtomatik geri ödəmə qaydası bu qaralamada təsdiqlənməmişdir və ayrıca təsdiq tələb edir."
        },
        {
          "heading": "6. Bağlanma sorğusu",
          "body": "Sorğu qeydə alınır; depozit, çıxarış və oyun məhdudlaşdırılır. Tam hüquqi bağlanma və vəsaitlərin taleyi operator proseduruna uyğun tamamlanır; avtomatik silinmə və ya avtomatik köçürmə bu qaralamada iddia edilmir."
        },
        {
          "heading": "7. Qeyd",
          "body": "Bu alətlər peşəkar yardımı əvəz etmir. Operatorun ölkə üzrə məcburi özünü məhdudlaşdırma reyestrləri bu qaralamada iddia edilmir."
        }
      ]
    },
    "disputes": {
      "title": "Mübahisələrin Həlli Siyasəti",
      "summary": "Şikayət, araşdırma və eskalasiya mərhələləri.",
      "sections": [
        {
          "heading": "1. Əhatə",
          "body": "Depozit və çıxarış, qəbz yoxlaması, bonus və promo, Şans Çarxı mükafatı, hesab məhdudiyyəti, profil və KYC, eləcə də (aktivləşdirildikdə) oyun sessiyası mübahisələri."
        },
        {
          "heading": "2. İlk müraciət",
          "body": "Mübahisəni əvvəlcə Canlı Dəstək vasitəsilə bildirin. Sorğu və ya sifariş nömrəsi, tarix, məbləğ, üsul və mümkün sübutları (qəbz, ekran görüntüsü) əlavə edin."
        },
        {
          "heading": "3. Daxili araşdırma",
          "body": "Operator jurnallar, ödəniş meta-məlumatı, bonus qeydləri və hesab statusunu yoxlaya bilər. Oyun nəticələri üçün provayder məlumatı tələb oluna bilər (xidmət aktivdirsə)."
        },
        {
          "heading": "4. Cavab müddəti — TƏSDİQ TƏLƏB OLUNUR",
          "body": "[TƏSDİQ TƏLƏB OLUNUR] Konkret cavab müddəti (məsələn, ilk cavab üçün saat və ya gün limiti) və mürəkkəb hallar üçün uzadılma qaydası sahibi tərəfindən təsdiqlənməyənə qədər bu sənəddə rəqəmsal SLA dərc edilmir. Sadə hallar adətən daha tez, üçüncü tərəf yoxlaması tələb edən hallar isə daha uzun baxıla bilər — dəqiq müddətlər təsdiqdən sonra əlavə olunacaq."
        },
        {
          "heading": "5. Nəticə",
          "body": "Qərar faktlara əsasən verilir. Uyğun olduqda düzəliş, status yeniləməsi və ya izah təqdim olunur. Saxta sənəd və ya sui-istifadə əlavə məhdudiyyətə səbəb ola bilər."
        },
        {
          "heading": "6. Eskalasiya — TƏSDİQ TƏLƏB OLUNUR",
          "body": "[TƏSDİQ TƏLƏB OLUNUR] Dəstək cavabından razı qalmadıqda növbəti eskalasiya addımları (daxili yuxarı səviyyə, xarici mübahisə orqanı, məhkəmə yurisdiksiyası) operator rekvizitləri və hüquqi ünvan təsdiqlənənə qədər bu sənəddə göstərilmir. Müvəqqəti olaraq istifadəçi Canlı Dəstək vasitəsilə yenidən baxış istəyə bilər; rəsmi xarici eskalasiya kanalı ayrıca təsdiq tələb edir."
        }
      ]
    }
  }
}
